import { Component, EventEmitter, forwardRef, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { AutocompleteComponent } from '../Autocomplete/autocomplete.component';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';


// eslint-disable-next-line @typescript-eslint/naming-convention
const GroupedAutoCompleteValueAccessor: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GroupedAutoCompleteComponent),
    multi: true
};

/**
 * ### Accessibility Usage
 * + ***ariaDescribedBy*** - use this if the widget has an external error message, or it needs extra description for screen reader. Use message's id
 */
@Component({
    selector: 'agpr-grouped-autocomplete',
    templateUrl: './grouped-autocomplete.component.html',
    styleUrls: ['./grouped-autocomplete.component.scss'],
    providers: [GroupedAutoCompleteValueAccessor],
    standalone: false
})
export class GroupedAutoCompleteComponent extends AutocompleteComponent {
    @Input() groupTemplate: TemplateRef<any>;
    @Input() itemsListTemplate: TemplateRef<any>;
    @Input() overlayTemplate: TemplateRef<any>;
    @Input() footerTemplate: TemplateRef<any>;
    @Input() optionGroupChildren: string;
    @Input() showEmptyMessage: boolean = false;
    @Input() clearOnBlur: boolean = false;
    @Input() inputType: string = 'text';
    @Input() ariaDescribedBy: string = '';
    @Input() resultListAriaLabel: string = 'results';

    @Output() viewAllInGroup: EventEmitter<any> = new EventEmitter();
    @Output() researchRequest: EventEmitter<any> = new EventEmitter();

    constructor(
        public domSanitizer: DomSanitizer,
        public localizationService: LocalizationService
    ) {
        super(domSanitizer, localizationService);
    }

    triggerViewAllInGroup(group: any) {
        this.viewAllInGroup.emit(group);
    }

    triggerResearchRequest(group: any) {
        this.researchRequest.emit(group);
    }

    writeValue(value: any | any[]): void {
        this.selectedItem = value;
    }
}
